/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScenarioContentTestMatch
 */
export interface InternalApiScenarioContentTestMatch {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioContentTestMatch
     */
    entityId?: string;
}

/**
 * Check if a given object implements the InternalApiScenarioContentTestMatch interface.
 */
export function instanceOfInternalApiScenarioContentTestMatch(value: object): value is InternalApiScenarioContentTestMatch {
    return true;
}

export function InternalApiScenarioContentTestMatchFromJSON(json: any): InternalApiScenarioContentTestMatch {
    return InternalApiScenarioContentTestMatchFromJSONTyped(json, false);
}

export function InternalApiScenarioContentTestMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioContentTestMatch {
    if (json == null) {
        return json;
    }
    return {
        
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
    };
}

export function InternalApiScenarioContentTestMatchToJSON(json: any): InternalApiScenarioContentTestMatch {
    return InternalApiScenarioContentTestMatchToJSONTyped(json, false);
}

export function InternalApiScenarioContentTestMatchToJSONTyped(value?: InternalApiScenarioContentTestMatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityId': value['entityId'],
    };
}

